import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Contactcta() {
  return <section data-section-id="260804" id="contactcta" className="bg-background text-foreground backdrop-blur-3xl ![padding:0px_0px_50px_0px]">
      <div className="container mx-auto px-4 flex flex-col items-center justify-center gap-8">
        <h2 className="text-[clamp(28px,4vw,32px)] font-black font-default text-foreground text-center tracking-tight">Klaar om meer uit jouw horecazaak te halen?</h2>
        
        <p className="text-[16px] md:text-[18px] text-foreground/80 text-center max-w-[700px] font-default leading-relaxed">We denken graag met je mee over hoe we jouw horecazaak structureel kunnen ondersteunen en versterken. Neem gerust contact met ons op voor een vrijblijvend gesprek.</p>
        
        <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 py-3 h-auto text-base font-bold transition-all shadow-md">
          <Link to="/ContactPage">Neem contact op</Link>
        </Button>
        
        
      </div>
    </section>;
}